<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-tabs>
        <a-tab-pane key="1" tab="图片库">
          <SmallSquare class='m-b-20'
            content="图片库是供您在各个应用模块(公众号模块除外)上传图片时，可以直接选用的图片；您可对图片进行改名、分组、删除操作，支持批量改分组和批量删除。" />
          <material :groupType='1' :key='1' />
        </a-tab-pane>
        <a-tab-pane key="2" tab="视频库">
          <SmallSquare class='m-b-20' content="1、视频库中的视频是用户直接上传或其他功能中上传的视频，可对视频进行改名、分组、删除操作，支持批量改分组和批量删除。视频一经删除，选用了该视频的页面将会无法播放此视频；
          2、为保障您的权益，维护高大永恒塑料制品有限公司平台的正常秩序，您在高大永恒塑料制品有限公司平台上传/发布视频素材内容需不违反法律法规的规定，" />
          <material :groupType='2' :key='2' />
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </a-layout>
</template>

<script>
  import material from './components/material'
  export default {
    components: { material },
  };
</script>